import React from "react";
import { connect } from "react-redux";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";
import * as Routes from "@js/generated/routes.js";

const SubscriberSearchResults = (props) => {
  if (props.loading) {
    return <LoadingSpinner width="15%" marginX="47.5%" />;
  }

  if (!props.query) {
    return "";
  }

  return (
    <div className="data-table-container subscriber-search-results">
      <div className="result-list-header">
        {I18n.t("notices.email_address_search_results", {
          query: props.query,
          list_type: "mailing lists",
        })}
      </div>
      <table className="data-table">
        <thead>
          <tr>
            <th scope="col" style={{ width: "325px" }}>
              {I18n.t("standard_fields.email")}
            </th>
            <th scope="col" style={{ width: "200px" }}>
              {I18n.t("headings.status")}
            </th>
            <th scope="col" style={{ width: "200px" }}>
              {I18n.t("phrases.mailing_list")}
            </th>
            <td />
          </tr>
        </thead>
        <tbody>
          {!props.results || props.results.length === 0 ? (
            <tr>
              <td colSpan={4}>
                {I18n.t("empty_table.subscriber_search_subscriber_results")}
              </td>
            </tr>
          ) : (
            props.results.map((result, ind) => {
              let subscriberPath = Routes.mailing_list_subscriber_path(
                result.mailing_list.id,
                result.id,
              );
              let mailingListPath = Routes.mailing_list_path(
                result.mailing_list.id,
              );
              let mailingListName = result.mailing_list.name;

              let organizationPath =
                result.organization &&
                Routes.organization_path(result.organization.id);
              let organizationName =
                result.organization && result.organization.name;

              return (
                <tr key={result.id}>
                  <td>
                    <a href={subscriberPath}>{result.email}</a>
                  </td>
                  <td>{result.status}</td>
                  <td>
                    <a href={mailingListPath}>{mailingListName}</a>
                    {organizationPath && organizationName && (
                      <div style={{ fontSize: "0.8em", paddingTop: "10px" }}>
                        (<a href={organizationPath}>{organizationName}</a>)
                      </div>
                    )}
                  </td>
                  <td className="actions">
                    <a
                      href={subscriberPath}
                      className="wordy-action-button view-button action-button button"
                    >
                      <i /> <span>{t("activerecord.models.subscriber")}</span>
                    </a>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  results: state.subscribersFound,
  loading: state.loading,
  query: state.query,
  error: state.error,
});

export default connect(mapStateToProps)(SubscriberSearchResults);
